<template>
  <wdw-dynbox class="thought-list" :title="listTitle" :watermark="watermark">
    <div v-if="!thoughtsLoading" class="thought-list-subheading">
      <b>Anzahl der gefilterten {{ domainStore.translate('thought.general.title-plural') }}</b>
      : {{ maxThoughtsCount }}
    </div>
    <div v-for="thought in thoughts" v-bind:key="thought.id">
      <thought-list-wrapper
        @click="handleClickEvent(thought.id, thought.topic.id, {})"
        :thought="thought"
        :config="config"
        @open-thought="openThought"
        @edit-thought="emitEditThought(thought.id, thought.topic.id)"
      />
    </div>
    <template v-if="thoughtsLoading">
      <vue-loading :loadingMessage="domainStore.translate('thought.general.message.loading-plural')" />
    </template>
    <template v-if="!thoughtsLoading && morethoughtsAvailable">
      <div class="text-center">
        <button
          ref="scrollTriggerElem"
          type="button"
          class="btn btn-primary btn-create-thought"
          autocomplete="off"
          @click="fetchThoughts"
        >
          {{ domainStore.translate('thought.general.message.load-more') }}
        </button>
      </div>
    </template>
    <template v-if="!thoughtsLoading && thoughts.length == 0">
      {{ domainStore.translate('thought.general.message.not-found-plural') }}
    </template>
  </wdw-dynbox>
</template>

<script>
import { thoughtStore } from '@/store/thought-store';
import { projectStore } from '@/store/project-store';
import { domainStore } from '@/store/domain-store';
import { ref, computed, watch } from 'vue';
import { useElementVisibility } from '@vueuse/core';
import VueLoading from '@/components/general/Loading';
import ThoughtListWrapper from '@/components/discuss/thought/ListWrapper.vue';
import WdwDynbox from '@/components/general/WdwDynbox.vue';
import ThoughtEventMixins from '@/mixins/ThoughtEventMixins';
import useThoughtEvents from '@/composables/thought/useThoughtEvents';

export default {
  name: 'ThoughtList',
  mixins: [ThoughtEventMixins],
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    load_more_on_scroll: {
      type: Boolean,
      required: false,
      default: false,
    },
    watermark: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup(props, context) {
    //---------------------------------------VARIABLE-------------------------------------
    const { emitOpenThought, emitEditThought } = useThoughtEvents(context);
    const scrollTriggerElem = ref(null);

    //----------------------------------------COMPUTED------------------------------------
    const thoughts = computed(() => {
      return thoughtStore.visibleThoughts();
    });
    const thoughtsAvailable = computed(() => {
      if (thoughts.value) {
        return thoughts.value.length > 0 ? true : false;
      }
      return false;
    });
    const thoughtsLoading = computed(() => {
      return thoughtStore.getState().loading;
    });
    const maxThoughtsCount = computed(() => {
      return thoughtStore.getState().maxThoughts;
    });
    const project = computed(() => {
      return projectStore.getState().project;
    });
    const listTitle = computed(() => {
      return project.value?.config?.thought_list_title ? project.value.config.thought_list_title : 'Beiträge';
    });
    const morethoughtsAvailable = computed(() => {
      return thoughtStore.getState().maxThoughts > thoughtStore.getState().thoughts.length;
    });

    //-----------------------------------------FUNCTION-------------------------------------
    function fetchThoughts() {
      if (!thoughtsLoading.value && morethoughtsAvailable.value) {
        // console.log('scroll loadMore triggered');
        thoughtStore.fetchMoreThoughts();
      }
    }
    function handleClickEvent(thoughtid, topicid, actions) {
      if (props.config.linkThoughtBox) {
        emitOpenThought(thoughtid, topicid, actions);
      }
    }
    function openThought(thoughtid, topicid, actions) {
      emitOpenThought(thoughtid, topicid, actions);
    }

    watch(useElementVisibility(scrollTriggerElem), (newVisible, oldVisible) => {
      if (newVisible && !oldVisible && props.load_more_on_scroll) {
        fetchThoughts();
      }
    });

    return {
      //-----------VARIABLE-----------
      thoughts,
      thoughtsAvailable,
      thoughtsLoading,
      listTitle,
      emitOpenThought,
      emitEditThought,
      openThought,
      handleClickEvent,
      maxThoughtsCount,
      domainStore,
      morethoughtsAvailable,
      fetchThoughts,
      scrollTriggerElem,
    };
  },

  components: {
    VueLoading,
    ThoughtListWrapper,
    WdwDynbox,
  },
};
</script>
<style lang="scss" scoped>
.thought-list-subheading {
  font-size: 15px;
}
</style>
